$(document).ready(function(){
    var backToTop = {

        self: this,
        offset: 500,

        showHide: function(scrolledWindow){
            if(scrolledWindow.scrollTop() > this.offset){
                $('#backToTop').addClass('show');
            }else {
                $('#backToTop').removeClass('show');
            }
        },

        goTop: function(){
            $('html, body').animate({
                scrollTop: 0
            }, 750);
        }

    };
    //On click back to top
    $('#backToTop').on('click',function(e){
        e.preventDefault();
        backToTop.goTop();
    });
    //On scroll show or hide button
    $(window).scroll(function(){
        backToTop.showHide($(this));
    });

    //=========Navbar===========//
    $(".navbar-default .nav a[data-slide]").click(function(e) {
        e.preventDefault();
        var goToElement = $(this).attr('data-slide');
        $('html, body').animate({
            scrollTop: $(goToElement).offset().top
        }, 750);
    });
    //=========Main Slider========//
    $("#kcm-main-slider").swiperight(function() {
        $(this).carousel('prev');
    });
    $("#kcm-main-slider").swipeleft(function() {
        $(this).carousel('next');
    });
    //=========Request=======//
    var sendMail = {

        self: this,

        request_mail: function (request_url,form_id,success_msg,err_msg){
            $.ajax({
                type: "GET",
                url: request_url,
                dataType: 'json',
                data: $(form_id).serialize(),
                success: function(data){
                    if(data.success){
                        $(form_id).trigger("reset");
                        $(form_id).hide().prepend("<div class='alert alert-success'>"+success_msg+"</div>").fadeIn('slow');
                    }else{
                        $(form_id).hide().prepend("<div class='alert alert-danger'>"+err_msg+"</div>").fadeIn('slow');
                        console.log('An error occurred, please try again.');
                    }
                    //Hiding message
                    $('.alert').delay(5000).fadeOut('slow');
                },
                error: function() {
                    $(form_id).hide().prepend("<div class='alert alert-danger'>"+err_msg+"</div>").fadeIn('slow');
                    //Hiding message
                    $('.alert').delay(5000).fadeOut('slow');
                    console.log('An error occurred, please try again.');
                }
            });
        }
    };

    $('#request button').on('click',function(e){
        $("form#request_form").validate({
            rules: {
                name: "required",
                email: {
                    required: true,
                    email: true
                },
                telephone: "required",
                employees: "required",
                outgoing_invoices: "required",
                incoming_invoices: "required"
            },
            messages: {
                name: "Molimo Vas unesite ime",
                email: "Molimo Vas unesite email",
                telephone: "Molimo Vas unesite telefon",
                employees: "Molimo Vas unesite broj zaposlenih",
                outgoing_invoices: "Molimo Vas unesite broj izlaznih faktura",
                incoming_invoices: "Molimo Vas unesite broj ulaznih faktura"
            },
            submitHandler: function() {
                sendMail.request_mail('/request_email', 'form#request_form','Vaš upit je uspešno poslat, hvala.', 'Došlo je do greške prilikom slanja, molimo Vas pokušajte ponovo, hvala.');
            }
        });
    });

    $('#contact button').on('click',function(e){
        $("form#contact_form").validate({
            rules: {
                name: "required",
                email: {
                    required: true,
                    email: true
                },
                subject: "required",
                message: "required"
            },
            messages: {
                name: "Molimo Vas unesite ime",
                email: "Molimo Vas unesite email",
                subject: "Molimo Vas unesite opis poruke",
                message: "Molimo Vas unesite poruku"
            },
            submitHandler: function() {
                sendMail.request_mail('/contact_email', 'form#contact_form','Vaša poruka je uspešno poslat, hvala.', 'Došlo je do greške prilikom slanja, molimo Vas pokušajte ponovo, hvala.');
            }
        });
    });

    //=========Clients=======//
    $('.clients__carousel').slick({
        arrows: true,
        slidesToShow: 5,
        prevArrow: '<a href="#" class="prev_arrow"><i class="fa fa-angle-left" aria-hidden="true"></i></a>',
        nextArrow: '<a href="#" class="next_arrow"><i class="fa fa-angle-right" aria-hidden="true"></i></a>',
        responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 4
            }
        },{
            breakpoint: 768,
            settings: {
                slidesToShow: 3
            }
        },{
            breakpoint: 480,
            settings: {
                slidesToShow: 2
            }
        }]
    });
    //=========References=======//
    $('.reference__carousel').slick({
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true,
        dotsClass: 'reference__carousel__indicator clearfix list-unstyled list-inline'
    });
    //=========Maps Configuration and B&W========//
    var style = [
        {
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#f5f5f5"
                }
            ]
        },
        {
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#616161"
                }
            ]
        },
        {
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "color": "#f5f5f5"
                }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#bdbdbd"
                }
            ]
        },
        {
            "featureType": "poi",
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#eeeeee"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#757575"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e5e5e5"
                }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9e9e9e"
                }
            ]
        },
        {
            "featureType": "road",
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#ffffff"
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#757575"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#dadada"
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#616161"
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9e9e9e"
                }
            ]
        },
        {
            "featureType": "transit",
            "stylers": [
                {
                    "saturation": -100
                },
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#e5e5e5"
                }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#eeeeee"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#c9c9c9"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "color": "#9e9e9e"
                }
            ]
        }
    ];

    var myCenter = new google.maps.LatLng(44.815172,20.470702);
    var mapCanvas = document.getElementById("map");
    var mapOptions = {center: myCenter, zoom: 16, scrollwheel: false};
    var map = new google.maps.Map(mapCanvas, mapOptions);
    // SET THE MAP TYPE
    var mapType = new google.maps.StyledMapType(style, {name:"Grayscale"});
    map.mapTypes.set('grey', mapType);
    map.setMapTypeId('grey');
    // SET THE MAP TYPE END
    var marker = new google.maps.Marker({
        position:myCenter,
        icon: 'assets/build/images/home/map.png'
    });
    marker.setMap(map);

    //Center on resize
    google.maps.event.addDomListener(window, "resize", function() {
        var center = map.getCenter();
        google.maps.event.trigger(map, "resize");
        map.setCenter(center);
    });
});